import React from 'react';
import { Col } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import { BasicDataTable } from 'app/components/DataTable';
import Card from 'app/components/Card';
import {
  GetColDataTable,
  getDataTableStructure,
  rowClasses
} from './utils/table';

import './styles.scss';

export default function TrackingDatatable({ orderId, includedTrackings }) {
  const intl = useIntl();

  return (
    <Col md={12}>
      <Card
        extraClass="tracking-datatable"
        icon="file"
        title={intl.formatMessage({
          id: 'controlpanel.global.trackings'
        })}
        body={
          <BasicDataTable
            id="tracking-datatable"
            columns={GetColDataTable(orderId)}
            entities={getDataTableStructure(includedTrackings)}
            keyField="deliveryNoteId"
            rowClasses={rowClasses}
          />
        }
      />
    </Col>
  );
}

TrackingDatatable.propTypes = {
  orderId: PropTypes.number.isRequired,
  includedTrackings: PropTypes.arrayOf(PropTypes.shape).isRequired
};
